module.exports = __webpack_public_path__ + "img/dk-flag.af13771e.png";